export function setEAAInstant(state: any, action: any): any {
  const log = action.payload.log;
  const logs = [...state.logs];
  const chartLogs = state.chart.logs;
  chartLogs.push(log.created_at);
  if (logs.unshift(log) > 10) {
    logs.pop();
  }
  return {
    ...state,
    statistics: {
      ...action.payload,
      today_events: state.statistics.today_events + 1,
      weekly_events: state.statistics.weekly_events + 1,
      monthly_events: state.statistics.monthly_events + 1,
      total_events: state.statistics.total_events + 1,
    },
    chart: { ...state.chart, logs: chartLogs },
    logs,
  };
}
